import React, { Component } from 'react';
import { connect } from 'react-redux';
import ADVAcceptanceWarningBanner from '../../Components/Account/ADVAcceptanceWarningBanner';
import TermsAcceptanceWarningBanner from '../../Components/Account/TermsAcceptanceWarningBanner';
import { PRIVACY_DOCUMENT_URL, TERMS_DOCUMENT_URL } from '../../constants';
import {
    currentTermsWereAccepted,
    isAccountOwner,
    userAcceptedADVAgreement
} from '../../redux/helper';
import ADVModal from '../Account/ADVModal';
import Section from '../Layout/Section';

class Miscellaneous extends Component {

    constructor(props) {
        super(props);

        this.state = {
            advModalIsOpen: false
        };
    }

    hideAdvModal() {
        this.setState({
            advModalIsOpen: false
        });
    }

    showAdvModal() {
        this.setState({
            advModalIsOpen: true
        });
    }

    render() {

        const { userAcceptedADVAgreement, currentTermsWereAccepted, isAccountOwner } = this.props;
        const { advModalIsOpen } = this.state;

        return (
            <React.Fragment>
                <Section
                    title="Rechtliche Hinweise"
                >


                    <p>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={PRIVACY_DOCUMENT_URL}
                        >
                            <span className="nav-link__lbl">Datenschutzerklärung</span>
                        </a>
                    </p>
                    <p>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={TERMS_DOCUMENT_URL}
                        >
                            <span className="nav-link__lbl">Allgemeine Geschäftsbedingungen</span>
                        </a>
                        {
                            currentTermsWereAccepted && isAccountOwner ?
                                <span style={{ marginLeft: 8 }}>
                                     {`(Akzeptiert am ${currentTermsWereAccepted} Uhr)`}
                                </span>
                                :
                                null
                        }
                    </p>

                    <p>
                        <span style={{ fontWeight: 400 }} className="btn--link-neutral"
                              onClick={() => this.showAdvModal()}
                        >
                            Auftragsverarbeitung
                        </span>
                        {
                            userAcceptedADVAgreement &&
                            <span style={{ marginLeft: 8 }}>
                                {`(Akzeptiert am ${userAcceptedADVAgreement} Uhr)`}
                            </span>
                        }
                    </p>

                </Section>

                <Section
                    title="Sonstige Hinweise"
                >
                    <p>Wir verwenden Icons der Material Design, Ionicon und PaymentFont
                        Iconsets.</p>
                    <p>Die Icons sind unter den folgenden Lizenzen registriert:<br /> <br />
                        - Material Design: Apache license version 2.0 <br /> (<a target="_blank"
                                                                                 rel="noopener noreferrer"
                                                                                 href="https://www.apache.org/licenses/LICENSE-2.0.html"
                        >https://www.apache.org/licenses/LICENSE-2.0.html</a>) <br /> <br />
                        - Ionicons: MIT License <br /> (<a target="_blank" rel="noopener noreferrer"
                                                           href="https://opensource.org/licenses/MIT"
                        >https://opensource.org/licenses/MIT</a>) <br /> <br />
                        - <a target="_blank" rel="noopener noreferrer"
                             href="https://paymentfont.com/"
                        >PaymentFont</a>: SIL OFL 1.1 License (Font) & MIT License (CSS) <br />
                        (<a target="_blank" rel="noopener noreferrer"
                            href="http://scripts.sil.org/OFL"
                        >http://scripts.sil.org/OFL </a>) <br />
                        (<a target="_blank" rel="noopener noreferrer"
                            href="http://opensource.org/licenses/mit-license.html"
                        >http://opensource.org/licenses/mit-license.html </a>) <br /> <br />
                    </p>
                </Section>
                <TermsAcceptanceWarningBanner ignoreStorage />
                <ADVAcceptanceWarningBanner ignoreStorage />
                {
                    advModalIsOpen && (
                        <ADVModal
                            closeModal={() => this.hideAdvModal()}
                            closeButtonText={userAcceptedADVAgreement && 'Schließen'}
                        />
                    )
                }
            </React.Fragment>
        );
    }
}


const mapStateToProps = state => ({
    userAcceptedADVAgreement: userAcceptedADVAgreement(state),
    currentTermsWereAccepted: currentTermsWereAccepted(state),
    isAccountOwner: isAccountOwner(state)
});


export default connect(mapStateToProps, null)(Miscellaneous);

